import { useTranslation } from 'react-i18next';
import React from 'react';

import { Container, ContentWrapper } from '../../styledComponents';
import {
  HeaderRow,
  IntegrationStatusLabelHost,
  LogoAndTitle,
} from '../IntegrationCard/styledComponents';
import {
  IntegrationSkeletonCardShell,
  LoadingStateRoot,
  SkeletonCardAvatar,
  SkeletonCardLine,
  SkeletonCardTitleLine,
  SkeletonCardsGrid,
  SkeletonDescriptionLines,
  SkeletonSearchBar,
  SkeletonSection,
  SkeletonSectionTitle,
  SkeletonStatusBadge,
} from './styledComponents';

const SKELETON_CARDS_PER_SECTION = 3;
const SKELETON_SECTION_COUNT = 2;

export const IntegrationsPageLoading = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <ContentWrapper>
        <LoadingStateRoot
          aria-busy="true"
          aria-label={t('ADMIN.INTEGRATIONS.LOADING')}
          aria-live="polite"
          role="status"
        >
          <SkeletonSearchBar aria-hidden />
          {Array.from({ length: SKELETON_SECTION_COUNT }).map((_, sectionIndex) => (
            <SkeletonSection key={`integration-skeleton-section-${sectionIndex}`}>
              <SkeletonSectionTitle aria-hidden />
              <SkeletonCardsGrid>
                {Array.from({ length: SKELETON_CARDS_PER_SECTION }).map((__, cardIndex) => (
                  <IntegrationSkeletonCardShell
                    key={`integration-skeleton-card-${sectionIndex}-${cardIndex}`}
                    aria-hidden
                  >
                    <HeaderRow>
                      <LogoAndTitle>
                        <SkeletonCardAvatar />
                        <SkeletonCardTitleLine />
                      </LogoAndTitle>
                      <IntegrationStatusLabelHost>
                        <SkeletonStatusBadge />
                      </IntegrationStatusLabelHost>
                    </HeaderRow>
                    <SkeletonDescriptionLines>
                      <SkeletonCardLine $width="92%" />
                      <SkeletonCardLine $width="72%" />
                    </SkeletonDescriptionLines>
                  </IntegrationSkeletonCardShell>
                ))}
              </SkeletonCardsGrid>
            </SkeletonSection>
          ))}
        </LoadingStateRoot>
      </ContentWrapper>
    </Container>
  );
};
